import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-tw';
dayjs.extend(duration);
dayjs.extend(relativeTime);

export function DateToTimestamp(date: Date | string | number | null | undefined): number {
    if (!date) return 0;
    if (typeof date === 'number') {
        return date > 1e11 ? Math.floor(date / 1000) : date;
    }
    const d = dayjs(date);
    return d.isValid() ? d.unix() : 0;
}

export function TimestampToDate(timestamp: number): Date {
    return new Date(timestamp * 1000);
}

export function SecondsToTimeString(seconds: number): string {
    const dur = dayjs.duration(seconds, 'seconds');
    return dur.locale("zh-tw").humanize()
}

export function getStartTimePresets(): { label: string; value: string }[] {
    return [
        { label: "7 天前", value: dayjs().subtract(7, "day").startOf("day").format("YYYY-MM-DD HH:mm:ss") },
        { label: "30 天前", value: dayjs().subtract(30, "day").startOf("day").format("YYYY-MM-DD HH:mm:ss") },
        { label: "今天 00:00", value: dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss") },
        { label: "昨天 00:00", value: dayjs().subtract(1, "day").startOf("day").format("YYYY-MM-DD HH:mm:ss") },
        { label: "本月 1 號", value: dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss") },
    ];
}

export function getEndTimePresets(): { label: string; value: string }[] {
    return [
        { label: "今天 23:59", value: dayjs().endOf("day").format("YYYY-MM-DD HH:mm:ss") },
        { label: "現在", value: dayjs().format("YYYY-MM-DD HH:mm:ss") },
        { label: "昨天 23:59", value: dayjs().subtract(1, "day").endOf("day").format("YYYY-MM-DD HH:mm:ss") },
        { label: "本月底", value: dayjs().endOf("month").endOf("day").format("YYYY-MM-DD HH:mm:ss") },
    ];
}

export function getRecentTimePresets(): { label: string; value: string }[] {
    return [
        { label: "現在", value: dayjs().format("YYYY-MM-DD HH:mm:ss") },
        { label: "1 小時前", value: dayjs().subtract(1, "hour").format("YYYY-MM-DD HH:mm:ss") },
        { label: "1 天前", value: dayjs().subtract(1, "day").format("YYYY-MM-DD HH:mm:ss") },
        { label: "1 週前", value: dayjs().subtract(1, "week").format("YYYY-MM-DD HH:mm:ss") },
    ];
}
